import { c as _c } from "react/compiler-runtime";
import { Buildings3Icon, PersonIcon } from "@navikt/aksel-icons";
import { ToggleGroup } from "@navikt/ds-react";
import type { MedUtenAGVisning } from "@/components/view/UnderBehandlingComponent";
interface Props {
  setVisning(val: MedUtenAGVisning): void;
}
export const MedUtenArbeidsgiverToggleGroup = t0 => {
  const $ = _c(6);
  const {
    setVisning
  } = t0;
  let t1;
  if ($[0] !== setVisning) {
    t1 = visning => setVisning(visning as MedUtenAGVisning);
    $[0] = setVisning;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ToggleGroup.Item value="MED_ARBEIDSGIVER"><Buildings3Icon aria-hidden={true} />Jeg har arbeidsgiver</ToggleGroup.Item>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ToggleGroup.Item value="UTEN_ARBEIDSGIVER"><PersonIcon aria-hidden={true} />Jeg har ikke arbeidsgiver</ToggleGroup.Item>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <div className="flex w-full justify-center mb-4"><ToggleGroup defaultValue="MED_ARBEIDSGIVER" onChange={t1}>{t2}{t3}</ToggleGroup></div>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};